<template>
  <div class="container app-details issue" :set="path = $route.path.split('/')[2]">
    <div v-for="issue in copy.issues" v-if="issue.image_name == path">
      <div class="app-details-top-flex">
        <div class="app-details-image">
          <img :src="'./assets/illustrations/'+issue.image_name+'.png'"></img>
        </div>
        <h2>{{ issue.category }}</h2>
      </div>
      <div class="app-details-intro">
        <p>{{ issue.text }}</p>
      </div>
    </div>
    <div class="app-issues active"
         v-for="candidate in copy.candidates"
         v-if="candidate.status == 'active' & copy.issues.find(d => d.image_name == path).candidates.includes(candidate.short_name)"
         :set="issue_name = copy.issues.find(d => d.image_name == path).category">
      <a :href="'./index.html#/candidates/'+candidate.short_name+'#Toggle'" class="app-details-header"><h4>{{ candidate.name }}</h4></a>
      <ul>
        <li v-for="issue in candidate.content" v-if="issue.category == issue_name"  v-html="md(issue.text)"></li>
      </ul>
    </div>
    <div class="dropped-out">
      <p class="dropped-out-header">Candidates who have dropped out:</p>
      <div class="app-issues inactive"
           v-for="candidate in copy.candidates"
           v-if="candidate.status != 'active' & copy.issues.find(d => d.image_name == path).candidates.includes(candidate.short_name)"
           :set="issue_name = copy.issues.find(d => d.image_name == path).category">
        <a :href="'./index.html#/candidates/'+candidate.short_name+'#Toggle'" class="app-details-header"><h4>{{ candidate.name }}</h4></a>
        <ul>
          <li v-for="issue in candidate.content" v-if="issue.category == issue_name" v-html="md(issue.text)"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  var md = require("markdown-it")();
  module.exports = {
    props: ['copy'],
    methods: {
      md: function(input) {
        return md.render(input);
      },
      mdInline: function(input) {
        return md.renderInline(input);
      }
    },
  }
</script>

<style scoped>

</style>
